export const checkboxHeaderCellClass = 'checkbox-table-header-cell';

export function createManagementTableSx({
  headerHeight = 46,
  rowHeight = 60,
  headerFontSize = 18,
  headerFontWeight = 500,
  cellFontSize = 16,
  cellPaddingX = 10,
  footerMinHeight = 72,
  footerPaddingX = 1,
  hideSelectedRowCount = true,
  checkboxColor,
  extraSx = {},
} = {}) {
  const baseSx = {
    border: '1px solid #DFE5F6',
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    overflow: 'hidden',
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#DFE5F6',
      minHeight: `${headerHeight}px !important`,
      maxHeight: `${headerHeight}px !important`,
      borderBottom: 'none',
    },
    '& .MuiDataGrid-columnHeaderRow': {
      backgroundColor: '#DFE5F6',
    },
    '& .MuiDataGrid-topContainer': {
      backgroundColor: '#DFE5F6',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#DFE5F6',
      padding: '0 !important',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    '& .MuiDataGrid-columnHeaderDraggableContainer': {
      backgroundColor: '#DFE5F6 !important',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      backgroundColor: '#DFE5F6',
      padding: '0 !important',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      backgroundColor: '#DFE5F6',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      borderColor: '#DFE5F6',
      borderBottom: 'none',
      color: '#1C1B1F',
      lineHeight: '24px',
      letterSpacing: '0.15px',
      outline: 'none',
      px: `${cellPaddingX}px !important`,
    },
    '& .MuiDataGrid-filler': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiDataGrid-scrollbarFiller': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiDataGrid-scrollbarFiller--header': {
      backgroundColor: '#DFE5F6 !important',
    },
    '& .MuiDataGrid-topContainer .MuiDataGrid-filler': {
      backgroundColor: '#DFE5F6 !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontSize: headerFontSize,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      fontWeight: headerFontWeight,
      color: '#1C1B1F',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-cell': {
      borderColor: '#DFE5F6',
      borderBottom: 'none',
      color: '#1C1B1F',
      fontSize: cellFontSize,
      lineHeight: '24px',
      letterSpacing: '0.15px',
      outline: 'none',
      display: 'flex',
      alignItems: 'center',
      px: `${cellPaddingX}px !important`,
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiDataGrid-row': {
      minHeight: `${rowHeight}px !important`,
      maxHeight: `${rowHeight}px !important`,
      backgroundColor: '#FFFFFF',
      borderBottom: 'none',
      borderTop: 'none',
      boxShadow: 'none',
    },
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#FFFFFF',
    },
    '& .MuiDataGrid-footerContainer': {
      borderTop: 'none',
      minHeight: footerMinHeight,
      px: footerPaddingX,
    },
    '& .MuiTablePagination-root': {
      color: '#1C1B1F',
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: '#1C1B1F',
    },
  };

  if (hideSelectedRowCount) {
    baseSx['& .MuiDataGrid-selectedRowCount'] = {
      visibility: 'hidden',
      width: 0,
    };
  }

  if (checkboxColor) {
    baseSx['& .MuiCheckbox-root.Mui-checked, & .MuiCheckbox-root.MuiCheckbox-indeterminate'] = {
      color: checkboxColor,
    };
  }

  baseSx[`& .${checkboxHeaderCellClass}`] = {
    paddingLeft: '0 !important',
    paddingRight: '24px !important',
  };

  return {
    ...baseSx,
    ...extraSx,
  };
}
